import styled from 'styled-components';
import { BodyRegularS } from '../../../../styles/globals';
import { ITheme } from '../../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;
  ${({ theme }) => `
  background: ${theme.colors.neutral.primary[5]};
`}
`;

export const ModalTopButton = styled(BodyRegularS)<{ isActive: boolean }>`
  cursor: pointer;
  font-weight: ${({ isActive }) => (isActive ? '700' : '300')};
  ${({ theme }) => `
  color: ${theme.colors.neutral.primary[80]};
`}
`;

interface IChildren {
  theme: ITheme;
}

export const Children = styled.div`
  padding: 20px;
  border-radius: 0 6px 6px 6px;

  ${({ theme }: IChildren) => `
    background: #FCFCFC;
    border: 1px solid ${theme.colors.neutral.primary[30]};
  `};
`;

export const Container = styled.div`
  width: 100%;
`;
